import { MDCChipSet } from "@material/chips";

export const initiateChips = () => {
    //Chips
    const chipsSelector = ".mdc-chip-set";
    const chips = [].map.call(
        document.querySelectorAll(chipsSelector),
        function(el) {
            return new MDCChipSet(el);
        }
    );
};

export const format = value => {
    value = value.split(".").join("");

    if (value.length > 3) {
        value =
            value.substring(0, value.length - 3) +
            "." +
            value.substring(value.length - 3, value.length);
    }

    return value;
};

export const numberWithCommas = x => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(".");
};

